export default __webpack_public_path__ + "static/media/leg-icon-sold.f4bd6783.png";